import superagent from 'superagent'
import { __API_URI__ } from '../utils/config'

export const markerGroupsSet = markerTypes => ({
  type: 'MARKER_GROUPS_SET',
  payload: markerTypes
})

export const markerGroupsFetchRequest = () => (dispatch, getState, token) => {
  const markerGroups = getState().markerGroups
  if (markerGroups && markerGroups.length > 0) return Promise.resolve(markerGroups)

  return new Promise(resolve => {
    superagent
      .get(`${__API_URI_2__}/markerGroup/get?folder=small35`)
      .set('Authorization', `Bearer ${token}`)
      .set('Platform', 'Web')
      .set('Version', `${__version__}`)
      .end((err, res) => {
        if (!res) return resolve(null)
        if (res.body) {
          dispatch(markerGroupsSet(res.body))
        }
        resolve(res.body)
      })
  })
}
